<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="100px" label-position='right' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="查询开始日期" )
                    el-date-picker.inputWidth(v-model='dataForm.statisticsStartDate' type="date" placeholder="请选择开始日期" value-format="yyyy-MM-dd")
              el-col(:md='6' :sm="12")
                el-form-item(label="查询结束日期" )
                    el-date-picker.inputWidth(v-model='dataForm.statisticsEndDate' type="date" placeholder="请选择结束日期" value-format="yyyy-MM-dd")
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='11' :sm="12")
                el-button(v-if="isAuth('ct:trainOrderOrder:export')",@click='exportExcel()',type='primary',icon='el-icon-download') 导 出
            el-col(:md='12' :sm="12" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-row(:gutter='20' style='padding-bottom:15px;')
            el-col(:span='12')
                el-card(shadow='hover')
                    .card-item
                        span.card-label 本期新增购买
                        span.card-value ￥{{ total.periodPurchaseAmount || 0 }}
            el-col(:span='12')
                el-card(shadow='hover')
                    .card-item
                        span.card-label 本期确认收入
                        span.card-value ￥{{ total.periodRevenue || 0 }}
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(prop='mobile',header-align='center',align='center',label='账号')
            el-table-column(prop='memberName',header-align='center',align='center',label='学员姓名')
            el-table-column(prop='periodPurchaseAmount',header-align='center',align='center',label='本期新增购买金额')
            el-table-column(prop='periodNewHours',header-align='center',align='center',label='本期新增权益课时')
            el-table-column(prop='periodConsumedHours',header-align='center',align='center',label='本期销课课时')
            el-table-column(prop='periodRevenue',header-align='center',align='center',label='本期确认收入')
            el-table-column(prop='periodRefundAmount',header-align='center',align='center',label='本期退款')
            el-table-column(prop='makeUpHours',header-align='center',align='center',label='本期补课课时')
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize' :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
</template>

<script>
import table from './table.js'

export default {
    name: 'train-group-order',
    data () {
        const pad = (n) => (n < 10 ? '0' + n : '' + n)
        const now = new Date()
        const monthStart = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-01`
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        const monthEnd = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(lastDay)}`
        return {
            dataForm: {
                statisticsStartDate: monthStart,
                statisticsEndDate: monthEnd
            },
            table: {
                columns: table.columns,
                data: null,
                size: 'mini',
                stripe: true,
                border: true
            },
            exportTitle: '培训班订单汇总',
            selChangeData: [],
            tableData: [],
            total: {},
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false
        }
    },
    mounted () {
        this.getDataList()
    },
    methods: {
        getDataList () {
            this.dataListLoading = true
            this.$http({
                url: this.$http.adornUrl('/pxTrain/preReceiveSummary'),
                method: 'post',
                data: {
                    pageNum: this.pageIndex,
                    pageSize: this.pageSize,
                    statisticsStartDate: this.dataForm.statisticsStartDate || '',
                    statisticsEndDate: this.dataForm.statisticsEndDate || ''
                }
            }).then(data => {
                if (data && data.code === 0) {
                    this.tableData = data.page.records
                    this.total = data.total || {}
                    this.totalPage = data.page.total || 0
                } else {
                    this.tableData = []
                    this.total = {}
                    this.totalPage = 0
                }
                this.dataListLoading = false
            }).catch(() => {
                this.tableData = []
                this.totalPage = 0
                this.dataListLoading = false
            })
        },
        queryList () {
            this.pageIndex = 1
            this.getDataList()
        },
        sizeChangeHandle (val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        currentChangeHandle (val) {
            this.pageIndex = val
            this.getDataList()
        },
        selectionChangeHandle (val) {
            this.selChangeData = val
        },
        exportExcel () {
            this.$http({
                url: this.$http.adornUrl('/pxTrain/preReceiveSummary'),
                method: 'post',
                data: {
                    pageNum: 1,
                    pageSize: 10000,
                    statisticsStartDate: this.dataForm.statisticsStartDate || '',
                    statisticsEndDate: this.dataForm.statisticsEndDate || ''
                }
            }).then(data => {
                if (data && data.code === 0) {
                    if (!data.page || !data.page.records || data.page.records.length === 0) {
                        this.$message.info('没有要导出的数据!')
                        return
                    }
                    const exportData = data.page.records
                    for (const i of exportData) {
                        i.mobile = i.mobile ? 'keepString' + i.mobile : ''
                        i.periodPurchaseAmount = i.periodPurchaseAmount ? '¥' + i.periodPurchaseAmount + '元' : ''
                        i.periodRevenue = i.periodRevenue ? '¥' + i.periodRevenue + '元' : ''
                        i.periodRefundAmount = i.periodRefundAmount ? '¥' + i.periodRefundAmount + '元' : ''
                    }
                    this.$export.excel({
                        columns: this.table.columns,
                        data: exportData,
                        title: this.exportTitle
                    }).then(() => {
                        this.$message.success('导出表格成功')
                    })
                } else {
                    this.$message.error((data && data.msg) || '导出失败')
                }
            }).catch(() => {
                this.$message.error('导出失败')
            })
        }
    }
}
</script>

<style>
.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
.card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-label {
  font-size: 14px;
  color: #606266;
}
.card-value {
  font-size: 22px;
  font-weight: bold;
  color: #02B90D;
}
</style>
